(function(window, quizSetupViewFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.QuizSetupView = quizSetupViewFactory(window,
      window.jQuery,
      namespace.templates,
      namespace.deviceInfo,
      namespace.viewHelper,
      namespace.textSanitizer,
      namespace.localizationStrings,
      namespace.languageCodes,
      namespace.events);
})(this, function(window, $, templates, deviceInfo, viewHelper, textSanitizer, localizationStrings, languageCodes, events) {
   'use strict';

   var _viewTemplate;
   var _$window = $(window);
   var FIRST_NAME_CLASS = 'first_name';
   var LAST_NAME_CLASS = 'last_name';

   if (templates && templates.quiz_setup_template) {
      _viewTemplate = templates.quiz_setup_template;
   } else {
      throw Error('quizSetupView: Quiz Setup Template not found.');
   }

   /**
    * @memberof TSC
    * @class QuizSetupView
    * @classdesc Quiz Setup View
    * @param {Object} $container - jQuery element where quiz setup view will be injected.
    * @param {Element} spContainer - Smart player container element.
    */
   var QuizSetupView = function($container, spContainer) {
      var _eventContainer = spContainer;
      var _$quizSetupView = null;
      var _$firstNameInput = null;
      var _$lastNameInput = null;
      var _$emailInput = null;
      var _$beginButton = null;
      var _$skipButton = null;

      var reverseNames = localizationStrings.getLanguage() === languageCodes.JAPANESE;

      var setupMessage = localizationStrings.strings.txtRequiredMessage;
      var enterEmail = localizationStrings.strings.txtEnterEmail;
      var enterName1;
      var enterName2;
      var beginButtonText = localizationStrings.strings.txtBegin;
      var skipControlText = localizationStrings.strings.txtSkip;
      var name1Class;
      var name2Class;

      if (reverseNames) {
         enterName1 = localizationStrings.strings.txtEnterLastName;
         enterName2 = localizationStrings.strings.txtEnterFirstName;
         name1Class = LAST_NAME_CLASS;
         name2Class = FIRST_NAME_CLASS;
      } else {
         enterName1 = localizationStrings.strings.txtEnterFirstName;
         enterName2 = localizationStrings.strings.txtEnterLastName;
         name1Class = FIRST_NAME_CLASS;
         name2Class = LAST_NAME_CLASS;
      }

      var createView = function() {
         var context = {
            setupMessage: setupMessage,
            enterName1: enterName1,
            enterName2: enterName2,
            name1Class: name1Class,
            name2Class: name2Class,
            enterEmail: enterEmail,
            beginButtonText: beginButtonText,
            skipControlText: skipControlText
         };

         var quizSetupMarkup = _viewTemplate(context);
         _$quizSetupView = $($.parseHTML(quizSetupMarkup));

         _$firstNameInput = _$quizSetupView.find('.' + FIRST_NAME_CLASS);
         _$lastNameInput = _$quizSetupView.find('.' + LAST_NAME_CLASS);
         _$emailInput = _$quizSetupView.find('.email_address');
         _$beginButton = _$quizSetupView.find('.tsc_begin_button');
         _$skipButton = _$quizSetupView.find('.skip_control');
      };

      var validateInput = function() {
         var firstName = _$firstNameInput.val().replace(/ /g, '');
         var lastName = _$lastNameInput.val().replace(/ /g, '');
         var email = _$emailInput.val().replace(/ /g, '');

         if (firstName !== '' && lastName !== '' && email !== '' && textSanitizer.isValidEmail(email)) {
            _$beginButton.removeAttr('disabled');
         } else {
            _$beginButton.attr('disabled', 'disabled');
         }
      };

      var destroy = function() {
         if (deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid()) {
            _$window.off('resize', viewHelper.scrollActiveElementIntoView);
            _$firstNameInput.off('focus keydown', viewHelper.scrollIntoView);
            _$lastNameInput.off('focus keydown', viewHelper.scrollIntoView);
            _$emailInput.off('focus keydown', viewHelper.scrollIntoView);
         }

         _$firstNameInput.off('keyup', validateInput);
         _$firstNameInput.off('change', validateInput);
         _$lastNameInput.off('keyup', validateInput);
         _$lastNameInput.off('change', validateInput);
         _$emailInput.off('keyup', validateInput);
         _$emailInput.off('change', validateInput);

         _$beginButton.off('click', beginQuiz);
         _$skipButton.off('click', skipQuiz);
      };

      var hideSkipButton = function() {
         _$skipButton.hide();
      };

      var beginQuiz = function(event) {
         event.preventDefault();

         var eventData = {
            firstName: _$firstNameInput.val().replace(/ /g, ''),
            lastName: _$lastNameInput.val().replace(/ /g, ''),
            email: _$emailInput.val().replace(/ /g, '')
         };

         _eventContainer.trigger(events.Quizzing.BeginClicked, eventData);
      };

      var skipQuiz = function(event) {
         event.preventDefault();
         _eventContainer.trigger(events.Quizzing.SkipClicked, {});
      };

      var bindEvents = function() {
         if (deviceInfo.isIPhoneOrIPod() || deviceInfo.isAndroid()) {
            _$window.on('resize', viewHelper.scrollActiveElementIntoView);
            _$firstNameInput.on('focus keydown', viewHelper.scrollIntoView);
            _$lastNameInput.on('focus keydown', viewHelper.scrollIntoView);
            _$emailInput.on('focus keydown', viewHelper.scrollIntoView);
         }

         _$firstNameInput.on('keyup', validateInput);
         _$firstNameInput.on('change', validateInput);
         _$lastNameInput.on('keyup', validateInput);
         _$lastNameInput.on('change', validateInput);
         _$emailInput.on('keyup', validateInput);
         _$emailInput.on('change', validateInput);

         _$beginButton.on('click', beginQuiz);
         _$skipButton.on('click', skipQuiz);

         $container.append(_$quizSetupView);

         if (viewHelper.elementOrChildHasFocus($container)) {
            _$firstNameInput.focus();
         }
      };

      createView();
      bindEvents();

      return Object.defineProperties({
         hideSkipButton: hideSkipButton,
         destroy: destroy
      }, {
         $view: {
            get: function() {
               return _$quizSetupView;
            }
         }
      });
   };

   return {
      /**
       *  Factory method that returns a new QuizSetupView object.
       *  @function create
       *  @memberof TSC.QuizSetupView
       *  @param {Object} $container - jQuery element where quiz setup view will be injected.
       *  @param {Element} spContainer - Smart player container element.
       *  @static
       *  @return QuizSetupView instance
       */
      create: QuizSetupView

   };
});
